import { Alert, AlertText, VStack } from '@vidahealth/vida-ui';

/**
 * Small "Where can I find this?"-style info card. Two stacked lines (title +
 * description) inside a solid info Alert. Used under inputs to explain what
 * the user should enter (e.g. invite codes, BEMSID, last-4 of SSN).
 */
export function AlertInfoCard({ title, description }: { title: string; description: string }) {
  return (
    <Alert action='info' variant='solid' className='flex-col items-start p-6'>
      <VStack space='xs'>
        <AlertText className='font-semibold' size='md'>
          {title}
        </AlertText>
        <AlertText size='sm'>{description}</AlertText>
      </VStack>
    </Alert>
  );
}
